module.exports = "/fonts/Ki.ttf?2a5ff834d12f21b421748941d6057d04";